import { safeApiRequest } from './apiClient';

const BASE = '/api/checklists';

export const fetchChecklistSablonByUrun = (icerikId, opts = {}) => {
  const islemTipi = opts.islemTipi ? String(opts.islemTipi) : 'Kurulum';
  const q = `?islemTipi=${encodeURIComponent(islemTipi)}`;
  return safeApiRequest(`${BASE}/sablon-by-urun/${encodeURIComponent(icerikId)}${q}`, { method: 'GET' });
};

export const fetchChecklists = (opts = {}) => {
  const q = opts.hepsi ? '?hepsi=true' : '';
  return safeApiRequest(`${BASE}${q}`, { method: 'GET' });
};

export const fetchChecklistById = (id) =>
  safeApiRequest(`${BASE}/${encodeURIComponent(id)}`, { method: 'GET' });

export const createChecklist = (payload) =>
  safeApiRequest(BASE, { method: 'POST', body: payload, skipCsrf: false });

export const updateChecklist = (id, payload) =>
  safeApiRequest(`${BASE}/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: payload,
    skipCsrf: false,
  });

export const deleteChecklist = (id) =>
  safeApiRequest(`${BASE}/${encodeURIComponent(id)}`, { method: 'DELETE', skipCsrf: false });

export const deleteChecklistPermanently = (id) =>
  safeApiRequest(`${BASE}/${encodeURIComponent(id)}/kalici`, {
    method: 'DELETE',
    skipCsrf: false,
  });

export const assignChecklistToProducts = (id, urunIcerikIdleri) =>
  safeApiRequest(`${BASE}/${encodeURIComponent(id)}/urunler`, {
    method: 'PATCH',
    body: { urunIcerikIdleri },
    skipCsrf: false,
  });

export const fetchChecklistAssignedProducts = (id) =>
  safeApiRequest(`${BASE}/${encodeURIComponent(id)}/urunler`, { method: 'GET' });

export const removeProductFromChecklist = (checklistId, urunId) =>
  safeApiRequest(
    `${BASE}/${encodeURIComponent(checklistId)}/urunler/${encodeURIComponent(urunId)}`,
    { method: 'DELETE', skipCsrf: false },
  );
